import { Tab, Tabs } from '@mui/material';
import React from 'react';

import type { Application } from 'api';
import useTranslate from 'hooks/useTranslate';

export const ALL_RETAINERS_TAB = 'all';

interface CaseSelectorProps {
    applications: Application[];
    selectedApplicationId: number | null;
    onSelect: (applicationId: number | null) => void;
}

export const CaseSelector: React.FC<CaseSelectorProps> = ({
    applications,
    selectedApplicationId,
    onSelect,
}) => {
    const { translate } = useTranslate();

    return (
        <Tabs
            value={selectedApplicationId ?? ALL_RETAINERS_TAB}
            onChange={(_event, value: number | typeof ALL_RETAINERS_TAB) =>
                onSelect(value === ALL_RETAINERS_TAB ? null : value)
            }
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
            <Tab
                value={ALL_RETAINERS_TAB}
                label={translate('allCases')}
                sx={{ textTransform: 'none', fontWeight: 600 }}
            />
            {applications.map((application) => (
                <Tab
                    key={application.id}
                    value={application.id}
                    label={`${application.program_name || translate('case')} #${application.id}`}
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                />
            ))}
        </Tabs>
    );
};
